import React from 'react';
import { Activity, Cpu, Sparkles, Sun, Moon, Search, Bell, User, Settings, LogOut } from 'lucide-react';
import './Header.css';

import { useToast } from '../../hooks/useToast';
import { CompanySelector } from './CompanySelector';

interface HeaderProps {
  isAiBrunixOpen: boolean;
  setIsAiBrunixOpen: (value: boolean) => void;
  closeAllMenus: () => void;
  toggleTheme: () => void;
  theme: string;
  currentTime: Date;
  isUserMenuOpen: boolean;
  setIsUserMenuOpen: (value: boolean) => void;
  setIsAuthenticated: (value: boolean) => void;
}

export const Header = ({
  isAiBrunixOpen,
  setIsAiBrunixOpen,
  closeAllMenus,
  toggleTheme,
  theme,
  currentTime,
  isUserMenuOpen,
  setIsUserMenuOpen,
  setIsAuthenticated
}: HeaderProps) => {
  const { notify } = useToast();

  return (
    <header className="header">
      <div className="header-left">
        <div className="header-status">
          <Activity size={14} className="status-icon" />
          <span>System_Status: Optimal</span>
        </div>
        <div className="header-divider" />
        <div className="header-load">
          <Cpu size={14} className="load-icon" />
          <span>Load: 12.4%</span>
        </div>
      </div>

      <div className="header-right">
        <CompanySelector />
        <button
          onClick={(e) => {
            e.stopPropagation();
            toggleTheme();
            const newThemeName = theme === 'dark' ? 'Claro' : 'Oscuro';
            notify("Tema Cambiado", `El tema del sistema ha cambiado a modo ${newThemeName}.`, "info");
          }}
          className="theme-btn"
          title={theme === 'dark' ? 'Cambiar a modo Claro' : 'Cambiar a modo Oscuro'}
        >
          {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
        </button>
        <div className="search-container" onClick={(e) => e.stopPropagation()}>
          <Search className="search-icon" size={14} />
          <input
            type="text"
            placeholder="SEARCH_SYSTEM..."
            className="search-input"
          />
        </div>
        <button
          onClick={(e) => e.stopPropagation()}
          className="notification-btn"
        >
          <Bell size={18} />
          <span className="notification-dot" />
        </button>
        <div className="user-section">
          <div className="time-display">
            <div className="time-time">
              {currentTime.toLocaleTimeString('en-US', { hour12: false })}
            </div>
            <div className="time-date">
              {currentTime.toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' })}
            </div>
          </div>

          <div className="header-divider" />

          <button
            onClick={(e) => {
              e.stopPropagation();
              const next = !isAiBrunixOpen;
              closeAllMenus();
              setIsAiBrunixOpen(next);
            }}
            className={`ai-brunix-btn ${isAiBrunixOpen ? 'active' : ''}`}
            title="Toggle Emi Assistant"
          >
            <Sparkles size={18} className={isAiBrunixOpen ? "pulse" : ""} />
            <span>EMI</span>
          </button>
        </div>
      </div>
    </header>
  );
};
